import React, { FunctionComponent, useState } from "react";

import styled, { css } from "styled-components";
import SV from "../../styles/variables";

import { Option } from "../../models/select";

import useOutsideClick from "../../hooks/useOutsideClick";

interface IProps {
  options: Option[];
  setState: React.Dispatch<React.SetStateAction<Option[]>>;
  className?: string;
}

const Select: FunctionComponent<IProps> = ({
  options,
  setState,
  className
}: IProps) => {
  const [openState, setStateOpen] = useState(false);
  const { name: title } = options.find(option => option.selected) || {
    name: "All Stores"
  };

  const ref = React.useRef(null);
  useOutsideClick(ref, e => {
    setStateOpen(false);
  });

  return (
    <SelectContainer ref={ref} className={className}>
      <SelectButton
        onClick={() => {
          setStateOpen(!openState);
        }}
      >
        <SelectTitle>{title}</SelectTitle>
        <SelectTick />
      </SelectButton>
      {openState && (
        <SelectItemsContainer>
          {options.map(option => {
            return (
              <SelectItem
                key={option.name}
                selected={option.selected}
                onClick={() => {
                  setState(opts => {
                    const newOpts = [...opts];
                    const currentOption = newOpts.find(
                      opt => opt.name == option.name
                    );
                    newOpts.map(opt => (opt.selected = false));
                    if (currentOption && !currentOption.selected) {
                      currentOption.selected = true;
                    }
                    return newOpts;
                  });
                }}
              >
                <Name>{option.name}</Name>
              </SelectItem>
            );
          })}
        </SelectItemsContainer>
      )}
    </SelectContainer>
  );
};

const selectHeight = 32;
const dropDownGap = 4;
const SelectContainer = styled.div`
  display: inline-block;
  position: relative;
`;

const SelectButton = styled.button`
  align-items: center;
  background-color: white;
  border-radius: 4px;
  border: solid 1px ${SV.colorP3};
  display: flex;
  height: ${selectHeight}px;
  line-height: 1;
  justify-content: space-between;
  padding: 8px;
  width: 140px;
`;

const SelectTitle = styled.span`
  color: ${SV.colorP2};
  font-size: 12px;
`;

const tickLength = 8;
const SelectTick = styled.span`
  border: solid ${SV.colorP3};
  border-width: 1px;
  border-right: 1px;
  border-top: 1px;
  display: block;
  height: ${tickLength}px;
  transform: rotate(-45deg) translateY(${-tickLength / 2}px);
  width: ${tickLength}px;
`;

const SelectItemsContainer = styled.div`
  align-items: center;
  background-color: white;
  border-radius: 4px;
  border: solid 1px #cedfff;
  display: flex column;
  justify-content: center;
  line-height: 0;
  padding: 16px 0;
  position: absolute;
  text-align: left;
  top: ${selectHeight + dropDownGap}px;
  width: 140px;
  z-index: 10;
`;

interface SelectProps {
  selected: boolean;
  onClick?: () => void;
}

const SelectItem = styled.div<SelectProps>`
  background-color: ${p => (p.selected ? SV.colorP1 : "white")};
  color: ${p => (p.selected ? SV.colorP3 : "black")};
  font-size: 16px;
  font-weight: 300;
  line-height: 1;
  padding: 8px 24px;
  width: 100%;
` as React.FunctionComponent<SelectProps>;

const Name = styled.span`
  font-weight: 400;
`;

export default Select;
